import React from 'react'
import GeneralHeader from '../GeneralHeader'

function ScoringMethodHeader() {
    return (
        <div>
            <GeneralHeader />
        </div>
    )
}

export default ScoringMethodHeader